import { DebugMenuProvider } from "../../../components/debug-menu";
import { KioskLoading } from "../../../components/kiosk-loading";
import { MobileAppCheckout } from "../../../views/mobile-app-checkout";
import { useKioskRuntimeController } from "../model/use-kiosk-runtime-controller";
import { KioskUnavailable } from "./kiosk-unavailable";
import { StaffLogin } from "./staff-login";
import { StaffResumeChoice } from "./staff-resume-choice";
import { StaffSetup } from "./staff-setup";

export function KioskPage() {
  const runtime = useKioskRuntimeController();
  const { state } = runtime;

  let content;

  if (state.phase === "booting" || state.phase === "recovering") {
    content = <KioskLoading />;
  } else if (state.phase === "staff-login") {
    content = (
      <StaffLogin
        onAuthenticated={runtime.onAuthenticated}
        onCancel={runtime.onStaffCancel}
      />
    );
  } else if (state.phase === "staff-resume-choice" && state.binding) {
    content = (
      <StaffResumeChoice
        binding={state.binding}
        onContinue={() => runtime.onContinueSavedBinding(state.binding!)}
        onReconfigure={runtime.onOpenSetup}
        onCancel={runtime.onStaffCancel}
      />
    );
  } else if (state.phase === "staff-setup") {
    content = (
      <StaffSetup
        previousBinding={state.binding}
        operator={runtime.operator}
        onComplete={runtime.onSetupComplete}
        onCancel={runtime.onSetupCancel}
      />
    );
  } else if (state.phase === "operational" && state.binding) {
    content = (
      <MobileAppCheckout
        storeKey={state.binding.storeKey}
        zoneId={state.binding.zoneId}
        placement={state.binding.placement}
        onPermissionDenied={runtime.onPermissionDenied}
        onSessionInvalid={runtime.onSessionInvalid}
        onServiceFailure={runtime.onServiceFailure}
        onServiceRecovered={runtime.onServiceRecovered}
        onStreamFailure={runtime.onStreamFailure}
        onStreamRecovered={runtime.onStreamRecovered}
        onCameraDegraded={runtime.onCameraDegraded}
        onCameraRecovered={runtime.onCameraRecovered}
        onCustomerViewChange={runtime.onCustomerViewChange}
      />
    );
  } else {
    content = (
      <KioskUnavailable
        permissionDenied={state.phase === "permission-denied"}
      />
    );
  }

  return (
    <DebugMenuProvider
      locked={runtime.locked}
      onStaffAccess={runtime.onStaffAccess}
      onReconfigure={
        state.phase === "operational" ? runtime.onOpenSetup : undefined
      }
      onLogout={state.phase === "operational" ? runtime.onLogout : undefined}
    >
      {content}
    </DebugMenuProvider>
  );
}
